﻿import {CookieService} from './cookies';
$(() => {
    let comparedCourses = [];
    $('.remove-compared-course').click(function () {
        if ($('.remove-compared-course').length == 1) {
            CookieService.SetCompareCoursesCookie(JSON.stringify([]));
            window.location.href = $(this).data('courses-url');
            return false;
        }

        const currentIdentifier = $(this).data('identifier')
        const url = new URL(location.href);
        url.searchParams.delete('courses');

        $('.remove-compared-course').each(function() {
            if (currentIdentifier != $(this).data('identifier')) {
                url.searchParams.append('courses', $(this).data('identifier'));
            }
        })
        location.assign(url.search);
        return false;
    })

    if($('.course-comparison-container').length) {
        let courses = CookieService.GetCompareCoursesCookie();
        if (courses) {
            comparedCourses = courses;
        }
    }

    if($('.modal-compare-courses').length) {
        $('.layout-wrapper.three-column-layout').append($('.modal-compare-courses'));
        $('.layout-wrapper.three-column-layout').append($('#modal-max-compared-courses'));
        $('.modal-compare-courses').show();
        let courses = CookieService.GetCompareCoursesCookie();
        if (courses) {
            comparedCourses = courses;
            for (var i = 0; i < comparedCourses.length; i++) {
                $('#course-' + comparedCourses[i].uniqueIdentifier).prop('checked', true);
            }
            setModalCourses();
        }
    }
    $('.main-content').on('click', '.course-selector-checkbox', function() {
        let checked = $(this).is(':checked');

        let uniqueIdentifier = $(this).val().toString();
        if (checked) {
            let courseDiv = $('.modal-course.empty').first();
            if (courseDiv.length == 0) {
                $(this).prop('checked', false);
                $('#modal-max-compared-courses').modal('show');
                return;
            }

            let venueType = $(this).data('venue-type');
            let title = $(this).data('title');

            let courseObject = createCourse(uniqueIdentifier, venueType, title);

            addCourse(courseDiv.data('position'), courseObject);

        } else {
            let courseDiv = $('.modal-course').filter('[data-unique-identifier="' + uniqueIdentifier + '"]').first();
            if (courseDiv.length == 0) {
                return;
            }
            removeCourse(courseDiv.data('position'));
        }
    });

    $('.modal-remove-course-block').click( function() {
        let position = $(this).data('position');
        let course = comparedCourses[position];
        $('#course-' + course.uniqueIdentifier).prop('checked', false);
        removeCourse(position);
    });

    $('#compare-courses-remove-all').click(function() {
        comparedCourses = [];
        $('.course-selector-checkbox').prop('checked', false);
        setModalCourses();
        CookieService.SetCompareCoursesCookie(JSON.stringify(comparedCourses));
    });

    $('#btn-compare-courses').click(function() {
        let coursesParam  = '?';
        for (var i = 0; i < comparedCourses.length; i++) {
            if (i > 0)
            {
                coursesParam += '&';
            }
            coursesParam += 'courses=' + comparedCourses[i].uniqueIdentifier;
        }
        window.open($(this).data('page-url') + coursesParam);
    });


    $('.modal-compare-courses-collapsible').on('hide.bs.collapse', function () {
        $('#collapse-compare-course-content .collapse-course-text').text($('#collapse-compare-course-content .collapse-course-text').data('show-text'));
        $('#collapse-compare-course-content .chevron').removeClass('bottom');
        $('.modal-compare-courses').animate({marginTop: -55 + 'px'}, 300);
    })
    $('.modal-compare-courses-collapsible').on('show.bs.collapse', function () {
        $('#collapse-compare-course-content .collapse-course-text').text($('#collapse-compare-course-content .collapse-course-text').data('hide-text'));
        $('#collapse-compare-course-content .chevron').addClass('bottom');
        $('.modal-compare-courses').animate({marginTop: -259 + 'px'}, 300);
    });
    $('.modal-compare-courses-collapsible').on('shown.bs.collapse', function () {
        $('.modal-compare-courses').css('margin-top', -$('.modal-compare-courses').height() + 'px');
    });

    function createCourse(uniqueIdentifier, venueType, title) {
        return {
            uniqueIdentifier: uniqueIdentifier,
            venueType: venueType,
            title: title
        };
    }

    function removeCourse(position) {
        comparedCourses.splice(position, 1);
        setModalCourses();
        CookieService.SetCompareCoursesCookie(JSON.stringify(comparedCourses));
    }
    function addCourse(position, courseObject, updateCourses = true) {
        let courseDiv = $('#modal-course-' + position);
        courseDiv.attr('data-unique-identifier', courseObject.uniqueIdentifier)
        courseDiv.find('.modal-course-venue').text(courseObject.venueType);
        courseDiv.find('.modal-course-title').text(courseObject.title);
        courseDiv.toggleClass('empty full');
        courseDiv.addClass('full').removeClass('empty');
        if (updateCourses) {
            comparedCourses[position] = courseObject;
            CookieService.SetCompareCoursesCookie(JSON.stringify(comparedCourses));
        }
    }

    function setModalCourses() {
        for (var i = 0; i <= 2; i++) {
            if (comparedCourses[i] !== undefined) {
                addCourse(i, comparedCourses[i], false);
            } else {
                let courseDiv = $('#modal-course-' + i);
                courseDiv.removeAttr('data-unique-identifier');
                courseDiv.addClass('empty').removeClass('full');
            }
        }
    }
});
